import React from 'react';
import {FormattedMessage} from 'react-intl';

const configs = (props) => {

    return (
        <div className="container col-12 mt-6 mr-0 ml-0">
            <h3 className="text-center text-secondary mb-5">Gestão de configurações</h3>
            <div className="row">
                <div className="col-lg-3 ">
                    <div className="list-group" id="list-tab" role="tablist">
                        <a className="list-group-item list-group-item-action active" id="list-1-list" data-toggle="list"
                           href="#list-1" role="tab" aria-controls="1">Formulário</a>
                        <a className="list-group-item list-group-item-action" id="list-2-list" data-toggle="list"
                           href="#list-2" role="tab" aria-controls="2">Configurações globais</a>
                    </div>
                </div>
                <div className="col-lg-9" style={{margin: "auto"}}>
                    <div className="tab-content" id="nav-tabContent">
                        <div className="tab-pane fade show active" id="list-1" role="tabpanel"
                             aria-labelledby="list-1-list">
                            <h4 className="text-secondary mt-3">Formulário</h4>
                            <hr></hr>
                            {/*chronic*/}
                            <h5 className="text-primary font-weight-normal">Lista de doenças crónicas</h5>
                            <ul className="list-group">
                                {props.chronic}
                            </ul>
                            <form onSubmit={props.chronicSubmit}>
                                <div className="form-group">
                                    <label htmlFor="number">Nova doença crónica</label>
                                    <div className="input-group mb-3">
                                        <input type="text"
                                               style={{padding: "10px", width: "300px"}}
                                               placeholder="Nova doença crónica"
                                               value={props.chronicValue}
                                               className="form-control" onChange={props.newChronicChange}/>
                                        <div className="input-group-append">
                                            <button
                                                className="btn btn-primary text-white" type="submit">
                                                Enviar
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            </form>

                            {/*meds*/}
                            <h5 className="text-primary font-weight-normal">Lista de fármacos</h5>
                            <ul className="list-group">
                                {props.med}
                            </ul>
                            <form onSubmit={props.medSubmit}>
                                <div className="form-group">
                                    <label htmlFor="number">Novo fármaco</label>
                                    <div className="input-group mb-3">
                                        <input type="text"
                                               style={{padding: "10px", width: "300px"}} placeholder="Novo fármaco"
                                               className="form-control" onChange={props.newMedChange}/>
                                        <div className="input-group-append">
                                            <button
                                                className="btn btn-primary text-white" type="submit">
                                                Enviar
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>

                            {/*physical*/}
                            <h5 className="text-primary font-weight-normal">Lista de atividades físicas</h5>
                            <ul className="list-group">
                                {props.physicalV}
                            </ul>
                            <form onSubmit={props.physicalVSubmit}>
                                <div className="form-group">
                                        <label htmlFor="number">Nova actividade física</label>
                                        <div className="input-group mb-3">
                                            <input type="text"
                                               style={{padding: "10px", width: "300px"}}
                                               placeholder="Nova actividade física"
                                               className="form-control" onChange={props.newPhysicalVChange}/>
                                        <div className="input-group-append">
                                            <button
                                                className="btn btn-primary text-white" type="submit">
                                                Enviar
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>

                            {/*spiro*/}
                            <h5 className="text-primary font-weight-normal">Lista de alterações de espirometria</h5>
                            <ul className="list-group"> {props.spiro}</ul>
                            <form onSubmit={props.spiroSubmit}>
                                <div className="form-group">
                                    <label htmlFor="number">Nova alteração</label>
                                    <div className="input-group mb-3">
                                        <input type="text"
                                               style={{padding: "10px", width: "300px"}} placeholder="Nova alteração"
                                               className="form-control" onChange={props.newSpiroChange}/>
                                        <div className="input-group-append">
                                            <button
                                                className="btn btn-primary text-white" type="submit">
                                                Enviar
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>

                            {/*visual*/}
                            <h5 className="text-primary font-weight-normal">Lista de alterações de rastreio visual</h5>
                            <ul className="list-group">
                                {props.visual}
                            </ul>
                            <form onSubmit={props.visualSubmit}>
                                <div className="form-group">
                                    <label htmlFor="number">Nova alteração</label>
                                    <div className="input-group mb-3">
                                        <input type="text"
                                               style={{padding: "10px", width: "300px"}} placeholder="Nova alteração"
                                               className="form-control" onChange={props.newVisualChange}/>
                                        <div className="input-group-append">
                                            <button
                                                className="btn btn-primary text-white" type="submit">
                                                Enviar
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>

                            {/*auditory*/}
                            <h5 className="text-primary font-weight-normal">Lista de alterações de rastreio
                                auditivo</h5>
                            <ul className="list-group">
                                {props.auditory}
                            </ul>
                            <form onSubmit={props.auditorySubmit}>
                                <div className="form-group">
                                    <label htmlFor="number">Nova alteração</label>
                                    <div className="input-group mb-3">
                                        <input type="text"
                                               style={{padding: "10px", width: "300px"}} placeholder="Nova alteração"
                                               className="form-control" onChange={props.newAuditoryChange}/>
                                        <div className="input-group-append">
                                            <button
                                                className="btn btn-primary text-white" type="submit">
                                                Enviar
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>

                            {/*ecg*/}
                            <h5 className="text-primary font-weight-normal">Lista de alterações de ECG</h5>
                            <ul className="list-group">
                                {props.ecg}
                            </ul>
                            <form onSubmit={props.ecgSubmit}>
                                <div className="form-group">
                                    <label htmlFor="number">Nova alteração</label>
                                    <div className="input-group mb-3">
                                        <input type="text"
                                               style={{padding: "10px", width: "300px"}} placeholder="Nova alteração"
                                               className="form-control" onChange={props.newEcgChange}/>
                                        <div className="input-group-append">
                                            <button
                                                className="btn btn-primary text-white" type="submit">
                                                Enviar
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>

                            {/*eritrogram*/}
                            <h5 className="text-primary font-weight-normal">Lista de alterações de Eritograma</h5>
                            <ul className="list-group">
                                {props.eritrogram}
                            </ul>
                            <form onSubmit={props.eritrogramSubmit}>
                                <div className="form-group">
                                    <label htmlFor="number">Nova alteração</label>
                                    <div className="input-group mb-3">
                                        <input type="text"
                                               style={{padding: "10px", width: "300px"}} placeholder="Nova alteração"
                                               className="form-control" onChange={props.newEritrogramChange}/>
                                        <div className="input-group-append">
                                            <button
                                                className="btn btn-primary text-white" type="submit">
                                                Enviar
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>

                            {/*leukogram*/}
                            <h5 className="text-primary font-weight-normal">Lista de alterações de Leucograma</h5>
                            <ul className="list-group">
                                {props.leukogram}
                            </ul>
                            <form onSubmit={props.leukogramSubmit}>
                                <div className="form-group">
                                    <label htmlFor="number">Nova alteração</label>
                                    <div className="input-group mb-3">
                                    <input type="text"
                                           style={{padding: "10px", width: "300px"}} placeholder="Nova alteração"
                                           className="form-control" onChange={props.newLeukogramChange}/>
                                        <div className="input-group-append">
                                            <button
                                                className="btn btn-primary text-white" type="submit">
                                                Enviar
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>

                        </div>
                        <div className="tab-pane fade" id="list-2" role="tabpanel" aria-labelledby="list-2-list">
                            <h4 className="text-secondary mt-3">Configurações globais</h4>
                            <hr></hr>
                            <form className="mt-2" onSubmit={props.configSubmit}>
                                <div className="form-group">
                                    <label htmlFor="first_name"><b>Tentativas máximas de login</b></label>
                                    <input type="text" className="form-control" id="first_name"
                                           value={props.loginAttempts} onChange={props.loginAttemptsChange}/>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="last_name"><b>Tentativas máximas de inserir código</b></label>
                                    <input type="text" className="form-control" id="last_name"
                                           value={props.codeAttempts} onChange={props.codeAttemptsChange}/>
                                </div>
                                <button type="submit" className="btn btn-primary text-white"><FormattedMessage
                                    id="update-profile"/></button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default configs;



// WEBPACK FOOTER //
// ./src/components/configs.js